import { CommonModule } from '@angular/common';
import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { I18nModule, OCC_USER_ID_CURRENT, Product, UrlModule, UserIdService } from '@spartacus/core';
import { fixProductName } from '../../../../../core/services/simple-tools';
import { RouterModule } from '@angular/router';
import { ProductCompareCheckModule } from '../../product-comparator-check/product-compare-check.module';
import { CollapseListModule } from '../../../../../components/collapse-list/collapse-list.module';
import { CollapseItem } from '../../../../../components/collapse-list/model/collapse.model';
import { ProductListItemService } from './product-list-item.service';
import { ProductPriceModule } from '../../product-price/product-price.module';
import { map, of } from 'rxjs';
import { ProductReplacementComponent } from '../../product-replacement/product-replacement.component';
import { CustomAddToCartModule } from '../../add-to-cart/add-to-cart.module';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';

@Component({
  selector: 'product-list-item-compact',
  standalone: true,
  imports: [
    CommonModule,
    RouterModule,
    I18nModule,
    UrlModule,
    ProductCompareCheckModule,
    CollapseListModule,
    ProductPriceModule,
    ProductReplacementComponent,
    CustomAddToCartModule,
  ],
  templateUrl: './product-list-item-compact.component.html',
  styleUrl: './product-list-item-compact.component.scss',
})
export class ProductListItemCompactComponent implements OnInit {
  @Input() product!: Product;
  @ViewChild('container') container!: ElementRef;

  isLogged$ = this.userIdService.getUserId().pipe(map(userID => userID === OCC_USER_ID_CURRENT));
  keyFeatures: CollapseItem[] = [];
  productAsObservable = () => of(this.product);
  fixProductName = fixProductName;

  addToCartForm = new UntypedFormGroup({
    quantity: new UntypedFormControl(1, { updateOn: 'blur' }),
  });

  constructor(
    private userIdService: UserIdService,
    private productListItemService: ProductListItemService,
  ) {}

  ngOnInit() {
    this.productListItemService.populateFeatures(this.product).then(features => {
      this.keyFeatures = features;
    });
  }

  toggleBoxStatus() {
    const $container = this.container.nativeElement;
    $container.classList.toggle('active');
  }
}
